<template>
  <mdb-navbar class="flexible-navbar white" position="top" double scrolling>
    <mdb-navbar-brand @click.native="toggleSideNav" class="button-collapse"><mdb-icon icon="bars"/></mdb-navbar-brand>
    <mdb-navbar-nav left>
      <mdb-breadcrumb><b>{{computedPage.activePage}}</b>&nbsp;- GWW-NEWSWEEK Wuppertal</mdb-breadcrumb>
    </mdb-navbar-nav>
    <mdb-navbar-toggler>
      <mdb-navbar-nav class="right-nav" right>
        <mdb-dropdown class="nav-item notifications-nav" tag="li">
          <mdb-dropdown-toggle slot="toggle" tag="li" outline="none" class="btn-transparent">
            <mdb-badge color="gww-red">3</mdb-badge> <mdb-icon icon="bell" far /> <span class="d-none d-md-inline-block">Nachrichten</span>
          </mdb-dropdown-toggle>
          <mdb-dropdown-menu>
            <mdb-dropdown-item>
              <mdb-icon icon="code-branch" class="mr-2" aria-hidden="true" />
              <span>Update: Version 0.01 ist verfü...</span>
              <span class="float-right"><mdb-icon icon="clock-o" arfaa-hidden="true"/>vor 5 Monaten</span>
            </mdb-dropdown-item>
            <mdb-dropdown-item>
              <mdb-icon icon="calendar-alt" far class="mr-2" aria-hidden="true" />
              <span>Erinnerung: GWW-NEWSWEE...</span>
              <span class="float-right"><mdb-icon icon="clock-o" arfaa-hidden="true"/>vor 10 Monaten</span>
            </mdb-dropdown-item>
            <mdb-dropdown-item>
              <mdb-icon icon="comment" far class="mr-2" aria-hidden="true" />
              <span>Nachricht: Parkplatz-Situatio...</span>
              <span class="float-right"><mdb-icon icon="clock-o" arfaa-hidden="true"/>vor 11 Monaten</span>
            </mdb-dropdown-item>
          </mdb-dropdown-menu>
        </mdb-dropdown>
        <mdb-nav-item>
          <mdb-icon far icon="comments" /><span class="clearfix d-none d-sm-inline-block">Support</span>
        </mdb-nav-item>
        <mdb-dropdown class="nav-item" tag="li">
          <mdb-dropdown-toggle slot="toggle" tag="li" outline="none" class="btn-transparent">
            <mdb-icon icon="user"/> <span class="clearfix d-none d-sm-inline-block">Profil</span>
          </mdb-dropdown-toggle>
          <mdb-dropdown-menu right>
            <mdb-dropdown-item>Mein Account</mdb-dropdown-item>
            <mdb-dropdown-item>Abmelden</mdb-dropdown-item>
          </mdb-dropdown-menu>
        </mdb-dropdown>
      </mdb-navbar-nav>
    </mdb-navbar-toggler>
  </mdb-navbar>
</template>

<script>
import { mdbNavbar, mdbNavbarBrand, mdbNavItem, mdbNavbarNav, mdbNavbarToggler, mdbBreadcrumb, mdbDropdown, mdbDropdownToggle, mdbDropdownMenu, mdbDropdownItem, mdbIcon, mdbBadge } from 'mdbvue'

export default {
  name: 'Navbar',
  props: {
    page: {
      type: String
    }
  },
  components: {
    mdbNavbar,
    mdbNavbarBrand,
    mdbNavItem,
    mdbNavbarNav,
    mdbNavbarToggler,
    mdbBreadcrumb,
    mdbDropdown,
    mdbDropdownToggle,
    mdbDropdownMenu,
    mdbDropdownItem,
    mdbIcon,
    mdbBadge
  },
  data () {
    return {
      activePage: this.page,
      toggle: false
    }
  },
  methods: {
    toggleSideNav () {
      this.toggle = !this.toggle
      this.$parent.$emit('toggle', this.toggle)
    }
  },
  computed: {
    computedPage () {
      return {
        activePage: this.page
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.navbar .nav-item {
  line-height: 24px;
  font-size: 16px;
}
.navbar .dropdown-toggle {
  padding: 0 10px;
  font-size: 16px;
}

.navbar ul {
  padding: 5px 0;
}

.navbar .btn {
  font-weight: 300;
}

.navbar-collapse {
  order: 0 !important;
}

.navbar .notifications-nav .dropdown-menu {
  width: 23rem; }

.navbar-expand-lg .navbar-nav {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  flex-direction: row;
}

.btn-transparent {
  background-color: transparent !important;
  color: #000;
  text-transform: none;
  box-shadow: none !important;
}

.btn-transparent:hover, .btn-transparent:active {
  box-shadow: none !important;
}

</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue